import Box from '@mui/material/Box';
import AcceptButton from './buttons/AcceptButton';
import SuccessToast from './toasts/SuccessToast';

type Props = {
  redirect: string
  acceptButtonText: string
}
  
export default function RecoverPasswordFourthInner(props: Props) {

  return (
    <Box>
      <Box sx={{margin: '0 5%'}}>
        <SuccessToast></SuccessToast>
      </Box>
      <Box className="centered" style={{padding: '27px 0'}}>
        <AcceptButton redirect={props.redirect} text={props.acceptButtonText}></AcceptButton>
      </Box>
    </Box>
  );
}